import axios from "axios";

const apiURL = process.env.VUE_APP_PUBLIC_API_URL;

export default {
    ReadCertificate: async function(component, licenseNumber) {
        component.dataErrors = [];
        return axios.get(`${apiURL}/certificate/${licenseNumber}`).then(response => {
            return response.data;
        }).catch(function() { ERRORS.Set(component, "Marriage License Certificate"); });
    }
};

var ERRORS = {
    Set: function(component, area) {
        component.dataErrors.push(area);
    }
};